import { createSelector } from "reselect";

/** @type {() => typeof import("./reducer").initState} */
export const selectRoot = (state) => state.statisticPages;

export const selectStatisticPage = createSelector(selectRoot, (root) => root.statisticPage);

export const selectPagesSettings = createSelector(selectRoot, (root) => root.pagesSettings);

export const selectPages = createSelector(selectPagesSettings, (pagesSettings) => {
  return pagesSettings?.page_details || [];
});

export const selectPagesSettingsId = createSelector(selectPagesSettings, (pagesSettings) => {
  return pagesSettings?.id || null;
});

export const selectOrderedPageIds = createSelector(selectPagesSettings, (pagesSettings) => {
  const orderedPages = pagesSettings?.settings?.order || [];
  const otherPages = (pagesSettings?.page_details || []).filter((page) => !orderedPages.includes(page.id));
  return [...orderedPages, ...otherPages.map((page) => page.id)];
});

export const selectOrderedPages = createSelector(selectOrderedPageIds, selectPages, (orderedPageIds, pages) => {
  return orderedPageIds.map((id) => pages.find((page) => page.id === id)).filter(Boolean);
});

export const selectAllStatisticPages = createSelector(selectRoot, (root) => root.allStatisticPages);

export const selectAllStatisticPageIds = createSelector(selectAllStatisticPages, (allStatisticPages) => {
  return allStatisticPages.map((page) => page.id);
});
